let _getWorkspaceId = () => null;

export function setWorkspaceIdGetter(getter) {
  _getWorkspaceId = getter;
}

const originalFetch = window.fetch.bind(window);

window.fetch = function patchedFetch(url, options = {}) {
  const headers = new Headers(options.headers || {});
  const workspaceId = _getWorkspaceId();
  if (workspaceId && url.toString().includes("/api/auth/")) {
    headers.set("X-Workspace-Id", workspaceId);
  }
  return originalFetch(url, { ...options, headers });
};
